import { initLazy } from './lazy.js'
import {initPage, initSingle} from './page.js'
import { initHeader } from 'Layout/header/index.js'
import { initChatWidget } from 'Components/chat_widget/index.js'
import { initCookieBar } from 'Components/cookie_bar/index.js'
import { Async } from "Core/async";
import {closeNav} from "../../../views/layout/header";

export let initialLoad = true
let headerHeight = 80

export const initApp = () => {
  initLazy()
  initHeader()
  initChatWidget()
  initCookieBar()
  initPage()

  const loadingScreen = document.getElementById('loading-screen')
  setTimeout(() => {
    loadingScreen.classList.remove('show')
  }, 150)

  const transitionScreen = document.getElementById('transition-screen')

  if (window.innerWidth < 800)
    headerHeight = 0

  new Async({
    element: 'main#async',
    transitionBodyClass: 'page-transition',
    minimalTransitionTime: 500,
    hasAnalytics: true,
    initFunction: function () {
      initPage()
    },
    startPageTransition: function () {
      transitionScreen.classList.add('show')
    },
    endPageTransition: function () {
      setTimeout(() => {
        transitionScreen.classList.remove('show')
        closeNav()
      }, 300)
    },
  }).init()
}

export const setInitialLoad = mode => {
  initialLoad = mode
}